const passwordMaxLenth = 255;

export {passwordMaxLenth};